export default "__VITE_ASSET__BCSX$Dbu__"